import InsuranceOffersTable from '../../OffersList/Insurance/InsuranceOffersTable'
import ProviderShow from '../ProviderShow'

const InsuranceShow = () => <ProviderShow OffersTableComponent={InsuranceOffersTable} />

export default InsuranceShow
